// src/features/editor/constants/fieldLimits.ts
export const FIELD_LIMITS = {
  COURSE_NAME: 200,
  // Сервер длину описания пока не ограничивает; 5000 — потолок AI-генерации и
  // перевода, Петя ставит тот же лимит на сервер (ответ бэка, п.7).
  COURSE_DESCRIPTION: 5000,
  LESSON_NAME: 200,
  BANNER_URL: 255,
  HEX_COLOR: 32,
  VIDEO_ID: 255,
  SUBMODULE_TITLE: 255,
  LANG_CODE: 10,
  IMAGE_URL: 1000,
  BODY_TEXT: 1000,
  BUTTON_TITLE: 255,
  BUTTON_LINK: 1000,
  BUTTON_TYPE: 50,
  BUTTON_SLUG: 255,
  BONUS_SLUG: 50,
  BONUS_TITLE: 75,
  BONUS_DESCRIPTION: 255,
  BONUS_PATTERN: 500,
  CONDITION_LINK: 2000,
  // Совпадает с лимитом сервера для баннеров (`file_is_too_large_5_mb`).
  UPLOAD_MAX_BYTES: 5 * 1024 * 1024,
  UPLOAD_MAX_MB: 5,
} as const

// Quiz block limits — synced with the backend's 2026-07-27 validation tightening,
// numbers ported 1:1 from oa-studio-prototype BlockEditor.tsx. Word limits are the
// reference's UI-facing rule; the *_CHARS values are the backend's hard character
// caps (kept as `maxLength` so a pathological input can never 422).
/** Сопоставление: пар не больше пяти (решение заказчика; на бэке — вопрос Пете, п.21). */
export const MATCH_LIMITS = {
  PAIRS_MIN: 2,
  PAIRS_MAX: 5,
  PAIR_TEXT_CHARS: 40, // текст одной стороны пары — лимит в UI; на бэке неизвестно
} as const

export const QUIZ_LIMITS = {
  QUESTION: 120, // yes_no statement — backend hard cap
  CHOICE_QUESTION: 80, // choice question — product limit in UI, backend allows QUESTION
  FILL_BLANK_STATEMENT: 80,
  FEEDBACK: 78, // correctFeedback / incorrectFeedback (+ En)
  OPTION_CHARS: 50, // choice option text — backend hard cap
  BLANK_WORD_WORDS: 1, // fill_blank word option — words in UI
  BLANK_WORD_CHARS: 25, // fill_blank word option — product limit in UI, backend allows 30
  OPTIONS_MAX_SINGLE: 4, // choice, multiAnswer = false
  OPTIONS_MAX_MULTI: 5, // choice, multiAnswer = true
  OPTIONS_MIN: 2, // below this, the delete button is hidden
  FILL_BLANK_OPTIONS_MAX: 5, // fill_blank: слов для выбора
} as const
